import header from "./duplex.webp";
import section1 from "./floor-plan-of-semi-detached-house.png";
import section2 from "./two-doors-of-one-house.jpg";
import section3 from "./bedroom-with-rainbow-poster.jpg";
import section4 from "./kitchen.jpg";
import section5 from "./interior-shot-modern-house-clothing-room.jpg";
import section6 from "./stylish-interior-modern-bedroom.jpg";
import section7 from "./livingroom.jpg";

export {
  header,
  section1,
  section2,
  section3,
  section4,
  section5,
  section6,
  section7,
};
